<template>
	<div>
		<div class="detailsBox">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="服务器配置" name="1"><ServerDeploy v-if="activeName == '1'"></ServerDeploy></el-tab-pane>
				<el-tab-pane label="坐席绑定" name="2"><SeatBinding v-if="activeName == '2'"></SeatBinding></el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
import ServerDeploy from '@/page/telecommunications/dialConfiguration/serverDeploy.vue';
import SeatBinding from '@/page/telecommunications/dialConfiguration/seatBinding.vue';
export default {
	components: {
		ServerDeploy, //服务器配置
		SeatBinding //坐席绑定
	},
	data() {
		return {
			activeName: '1'
		};
	},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event);
		},
	}
};
</script>
<style scoped lang="scss">
.details_header {
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;
	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}
	margin-bottom: 20px;
	cursor: pointer;
}
.detailsBox {
	padding: 20px;
	box-sizing: border-box;
}
</style>
